import React from "react";

import { SubBar, MainView } from "lib/index";

export default class NotFoundView extends React.PureComponent {
  render() {
    const message = (
      <div>
        <p>{I18n.t("papp.app.NotFoundView.message")}</p>
      </div>
    );

    return (
      <MainView.Container>
        <MainView.Content grayBackground hasSubBar>
          <MainView.Dimmer
            placeholderTitle={I18n.t("papp.app.NotFoundView.title")}
            placeholderMessage={message}
            placeholderIcon="help"
          />
        </MainView.Content>
      </MainView.Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/NotFoundView.jsx